import createIcon from '../../createIcon';

/**
 * @component @name Shop2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA5LjVIMVYyMC41QzEgMjEuNjEgMS44OSAyMi41IDMgMjIuNUgxOVYyMC41SDNWOS41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4IDUuNVYzLjVDMTggMi4zOSAxNy4xMSAxLjUgMTYgMS41SDEyQzEwLjg5IDEuNSAxMCAyLjM5IDEwIDMuNVY1LjVINVYxNi41QzUgMTcuNjEgNS44OSAxOC41IDcgMTguNUgyMUMyMi4xMSAxOC41IDIzIDE3LjYxIDIzIDE2LjVWNS41SDE4Wk0xMiAzLjVIMTZWNS41SDEyVjMuNVpNMTIgMTUuNVY4LjVMMTcuNSAxMkwxMiAxNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Shop2 = createIcon('Shop2', [
  ['path', { d: 'M3 9.5H1V20.5C1 21.61 1.89 22.5 3 22.5H19V20.5H3V9.5Z', key: '176tdw' }],
  [
    'path',
    {
      d: 'M18 5.5V3.5C18 2.39 17.11 1.5 16 1.5H12C10.89 1.5 10 2.39 10 3.5V5.5H5V16.5C5 17.61 5.89 18.5 7 18.5H21C22.11 18.5 23 17.61 23 16.5V5.5H18ZM12 3.5H16V5.5H12V3.5ZM12 15.5V8.5L17.5 12L12 15.5Z',
      key: 'x1ircc',
    },
  ],
]);

export default Shop2;
